import React from "react";
import "./SkillBubbleChart.css";

const SkillBubbleChart = (props) => {
  return (
    <div className="skillChart">
      {props?.data?.map((element, index) => {
        const length = element?.name?.length;
        return (
          <div
            key={index}
            className={`skill-${index}`}
            title={`${element?.name} \n ${element?.value}`}
          >
              <p className="name">
                {element?.name?.length > 15 && index > 4
                  ? element?.name.substr(0, 15) + "..."
                  : element?.name}
                  <p>{element?.value} </p>
              </p>
          </div>
        );
      })}
    </div>
  );
};

export default SkillBubbleChart;
